import { render, staticRenderFns } from "./CmgMealBuilderFooter.vue?vue&type=template&id=cdee659c&scoped=true&lang=pug&"
import script from "./cmg-meal-builder-footer.ts?vue&type=script&lang=ts&"
export * from "./cmg-meal-builder-footer.ts?vue&type=script&lang=ts&"
import style0 from "./CmgMealBuilderFooter.vue?vue&type=style&index=0&id=cdee659c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdee659c",
  null
  
)

export default component.exports